import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "tag",
  "use": "tag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"tag\"><defs><style>#tag .cls-1{fill:none}</style></defs><title>资源 89</title><g id=\"tag_图层_2\" data-name=\"图层 2\"><g id=\"tag_图层_1-2\" data-name=\"图层 1\"><g id=\"tag_tag-o\"><path id=\"tag_Shape\" d=\"M10.58 22.34A1.88 1.88 0 0 0 11 22l5.6-5.53L22.21 11a1.34 1.34 0 0 0 .22-.31v-.05a.75.75 0 0 0 .05-.16 1.66 1.66 0 0 0 0-.22v-7a1.75 1.75 0 0 0-1.75-1.73H14a1.1 1.1 0 0 0-.59.17.72.72 0 0 0-.22.17L2 13.11l-.18.2a1.6 1.6 0 0 0-.23.45 1.92 1.92 0 0 0-.09.4v.08a1.67 1.67 0 0 0 .12.7.19.19 0 0 1 0 .07l.06.11a.75.75 0 0 0 .07.12l.13.18.11.12L8.54 22a1.74 1.74 0 0 0 2.04.34zM20.85 3.19v6.75l-5.43 5.36-5.6 5.53h-.08l-6.59-6.48 11.06-11.2h6.58a.06.06 0 0 1 .06.04zM19.5 6.27a1.69 1.69 0 0 0-1.68-1.67 1.67 1.67 0 1 0 1.68 1.67z\" /></g><path id=\"tag_Rectangle_21\" data-name=\"Rectangle 21\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/tag.svg
// module id = j6Ty
// module chunks = 6